/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceFullDto } from '../../models/device-full-dto';

export interface GetDevicePageData$Params {
  cropId?: number;
  customerId?: number;
  facilityGroupId?: number;
  includeNonActive?: boolean;
}

export function getDevicePageData(http: HttpClient, rootUrl: string, params?: GetDevicePageData$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceFullDto>> {
  const rb = new RequestBuilder(rootUrl, getDevicePageData.PATH, 'get');
  if (params) {
    rb.query('cropId', params.cropId, {});
    rb.query('customerId', params.customerId, {});
    rb.query('facilityGroupId', params.facilityGroupId, {});
    rb.query('includeNonActive', params.includeNonActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeviceFullDto>;
    })
  );
}

getDevicePageData.PATH = '/api/regdevice/full';
